module.exports = __webpack_public_path__ + "static/media/header-bg-min.3237a058.jpg";